module.exports = __webpack_public_path__ + "static/img/brees-2014-slide-7.07f93c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-slide-7.jpg
// module id = G3g6
// module chunks = 1